import { LOCALE_KEY } from '@fx-ui/intl';
import { localStorageManager, SuiteId, type UserTenantsFilter } from '@libs/shared';
import { StorageKeyManager } from '../utils/storage-key';

export class GlobalState {
    // 域名 + 二级路径
    origin?: string;
    isMobile?: boolean;

    /** 临时参数：管理后台站点及二级路径，缺省时沿用 origin */
    platformSite?: string;

    /** 是否启用外部用户灰度控制 */
    externalUserBeta? = false;

    // 云平台接口请求头参数
    csrf?: string;
    csrfToken?: Record<string, string>;
    /** SDK 请求附加头，与内置请求头合并 */
    reqHeaders?: Record<string, any>;
    version?: string;

    isCors = false;
    onRefreshToken?: () => Promise<string>;

    // 语言
    localeKey?: LOCALE_KEY;
    defaultLocaleKey?: LOCALE_KEY;

    // 当前套件id
    suiteId: number | undefined;

    // 浩客是否已经完成初始化
    isHowxmInit = false;

    userTenantsFilter?: UserTenantsFilter;
    /** 自定义切换企业实现 */
    onSwitchCorp?: (tenantId: string) => Promise<void>;

    // 心跳轮询
    heartbeatInterval: null | NodeJS.Timeout = null;
    heartbeatCallback?: (res: {
        type: 'error' | 'switchCorp' | 'switchUser';
        error?: { httpCode: number; errorCode?: number };
        tenantId?: string;
        userId?: string;
    }) => void;

    // 全局变量
    options?: {
        // 区号列表及其国际化
        calling_code_list?: {
            label: string;
            children: {
                value: string;
                text: Record<LOCALE_KEY, string>;
            }[];
        }[];
        // 密码加密算法及公钥
        pki?: {
            algorithm: string;
            keys: {
                public_key: string;
            };
        };
        function_map: {
            /** 启信宝服务 */
            qixin_search_service?: boolean;
            corp_coop?: boolean;
            member_auto_sync?: boolean;
            contact_phone?: boolean;
            platform_sms?: boolean;
            coin?: boolean;
            register_persona?: boolean;
        };
        // 人机验证方式&参数
        captcha?: {
            type: 'svg' | 'cloud_flare' | 'google_recaptcha';
            params?: {
                site_key: string;
            };
        };
        // 商务咨询链接
        customize_better_version?: string;
        links?: {
            // 云币购买链接
            purchase_coin?: string;
        };
        // 帮助文档链接
        help_docs?: {
            coin?: string;
        };
        // 浩客 appId
        howxm_project_id?: string;
    };

    /**
     * 埋点方法
     * @param evt 事件
     * @param ext 参数
     */
    tracker?: (evt: string, ext?: Record<string, any> | string) => void;

    get accessToken() {
        return localStorageManager.get(this.getAccessTokenKey());
    }

    setAccessToken(accessToken?: string) {
        localStorageManager.set(this.getAccessTokenKey(), accessToken);
    }

    private getAccessTokenKey() {
        return StorageKeyManager.getAccessTokenKey(this.suiteId ?? SuiteId.PLATFORM);
    }
}

export const globalState = new GlobalState();
